var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wx-container"},[_c('img',{staticClass:"logoIcon",attrs:{"src":_vm.warnImg}})])
}
var staticRenderFns = []

export { render, staticRenderFns }